import React from 'react'
import * as Sentry from '@sentry/react'
import ReactDOM from 'react-dom/client'
import App from './App'
import reportWebVitals from './reportWebVitals'

Sentry.init({
  dsn: import.meta.env.VITE_APP_SENTRY_LARAVEL_DSN,
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  tunnel: import.meta.env.VITE_APP_SENTRY_TUNNEL,
})

ReactDOM.createRoot(document.getElementById('app')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)

reportWebVitals()
